import React from 'react';
import { createStaggeredAnimation } from '../../styles/animation';

/**
 * A reusable component for applying staggered animations to lists
 *
 * @param {string} containerClass - The class name of the container to animate
 * @param {string} itemSelector - The selector for the items within the container (default: '> div')
 * @param {string} customCSS - Additional custom CSS to include
 */
const StaggeredAnimation = ({ 
  containerClass, 
  itemSelector = '> div', 
  customCSS = '' 
}) => {
  const animationCSS = createStaggeredAnimation(containerClass, itemSelector);
  
  return (
    <style>
      {animationCSS}
      {customCSS}
    </style>
  );
};

export default StaggeredAnimation; 